@if (summary) {
    <div class="row g-3 mb-3 mt-1">
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Spend</div>
                    <div class="fs-3 fw-bold">{{ summary.spend | currency }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Lines</div>
                    <div class="fs-3 fw-bold">{{ summary.lineCount | number }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Vendors</div>
                    <div class="fs-3 fw-bold">{{ summary.vendorCount | number }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Distinct descriptions</div>
                    <div class="fs-3 fw-bold">{{ summary.distinctDescriptions | number }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="row g-3 mb-3">
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Distinct part numbers</div>
                    <div class="fs-3 fw-bold">{{ summary.distinctPartNumbers | number }}</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Lines missing a part number</div>
                    <div class="fs-3 fw-bold">{{ summary.missingPartPercent | number: '1.0-1' }}%</div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-bg-light h-100">
                <div class="card-body">
                    <div class="text-muted small">Lines missing a unit</div>
                    <div class="fs-3 fw-bold">{{ summary.missingUnitPercent | number: '1.0-1' }}%</div>
                </div>
            </div>
        </div>
    </div>
}
<p class="text-muted small">
    Category totals cover every invoice category in the date range. The cards above follow the category filter. Current invoices
    only, and dates after today are left out.
</p>
<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="categoryGrid"></action-toolbar-count>
                    <grid-export [grid]="gridCategories" [name]="'Purchased Material Categories'"></grid-export>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <grid-column-group [grid]="categoryGrid"></grid-column-group>
                <wj-flex-grid
                    id="gridCategories"
                    #gridCategories
                    appAutoSize
                    [padding]="73"
                    [isReadOnly]="true"
                    (initialized)="categoryGrid.initialize(gridCategories)"
                    (destroy)="categoryGrid.destroy()"
                    [itemsSource]="categoryGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="180" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="120" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Vendors'" [binding]="'vendorCount'" [width]="120" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="160" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="gridCategories"></grid-selection-calculation>
            </div>
        </div>
    </div>
</div>
